document.addEventListener('DOMContentLoaded', function () {
  // Function to handle toggle behavior
  function toggleAccordion(e) {
      const toggle = e.target.closest('[data-accordion_identifier-toggle]');
      if (!toggle) return; // Ignore if the target is not a toggle

      const key = toggle.getAttribute('data-accordion_identifier-toggle');
      if (!key) return; // If no key, do nothing

      // Find the associated accordion panel using the key
      const panel = document.querySelector(`[data-accordion_identifier="${key}"]`);
      if (!panel) return; // If no matching panel, do nothing

      // Check if the panel is currently open or closed
      const isOpen = panel.getAttribute('aria-hidden') === 'false';
      if (isOpen) {
          // Close the panel
          panel.setAttribute('aria-hidden', 'true');
          panel.hidden = true;
          toggle.setAttribute('aria-expanded', 'false');
          // Change all the SVGs to the "closed" one
          changeAllSvgs(toggle, true);
      } else {
          // Open the panel
          panel.setAttribute('aria-hidden', 'false');
          panel.hidden = false;
          toggle.setAttribute('aria-expanded', 'true');
          // Change all the SVGs to the "open" one
          changeAllSvgs(toggle, false);
      }
  }

  // Function to open accordion programmatically
  function openAccordion(key) {
      const toggle = document.querySelector(`[data-accordion_identifier-toggle="${key}"]`);
      const panel = document.querySelector(`[data-accordion_identifier="${key}"]`);
      
      if (!toggle || !panel) return;
      
      // Check if already open
      const isOpen = panel.getAttribute('aria-hidden') === 'false';
      if (!isOpen) {
          // Open the panel
          panel.setAttribute('aria-hidden', 'false');
          panel.hidden = false;
          toggle.setAttribute('aria-expanded', 'true');
          changeAllSvgs(toggle, false);
      }
  }

  // Function to update all SVGs inside the toggle
  function changeAllSvgs(toggle, isClosed) {
      // Find all SVG elements inside the toggle button
      const svgs = toggle.querySelectorAll('.marquee-icon svg');
      if (!svgs.length) return; // If no SVGs found, do nothing

      // Loop through all SVG elements and update them
      svgs.forEach((svg) => {
          if (isClosed) {
              // Replace with the "closed" SVG (when accordion is closed)
              svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
              svg.setAttribute('width', '17');
              svg.setAttribute('height', '17');
              svg.setAttribute('viewBox', '0 0 17 17');
              svg.setAttribute('fill', 'none');
              svg.innerHTML = '<path d="M16.5 9.44118H9.50392V16.5H7.46471V9.44118H0.5V7.55882H7.46471V0.5H9.50392V7.55882H16.5V9.44118Z" fill="white"/>';
          } else {
              // Replace with the "open" SVG (when accordion is open)
              svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
              svg.setAttribute('width', '20');
              svg.setAttribute('height', '2');
              svg.setAttribute('viewBox', '0 0 20 2');
              svg.setAttribute('fill', 'none');
              svg.innerHTML = '<path d="M20 0V2H0V0H20Z" fill="white"/>';
          }
      });
  }

  // Initialize the accordion to be closed and SVGs to "closed"
  document.querySelectorAll('[data-accordion_identifier-toggle]').forEach((toggle) => {
      const panel = document.querySelector(`[data-accordion_identifier="${toggle.getAttribute('data-accordion_identifier-toggle')}"]`);

      // Ensure the panel is hidden on load and SVGs are set to "closed"
      if (panel) {
          panel.setAttribute('aria-hidden', 'true');
          panel.hidden = true;
          toggle.setAttribute('aria-expanded', 'false');
          changeAllSvgs(toggle, true); // Set to closed SVGs on load
      }

      // Add event listener for clicks on all elements with a toggle action
      toggle.addEventListener('click', toggleAccordion);
  });

  // New logic to hide sections when data-empty_accordion="true"
  const emptyAccordion = document.querySelector('[data-empty_accordion="true"]');
  if (emptyAccordion) {
      const marquee = document.querySelector('.marquee-section');
      const accordionContent = document.querySelector('.custom-accordion-content-wrapper');
      
      if (marquee) {
          marquee.style.display = 'none'; // Hide the marquee section
      }
      if (accordionContent) {
          accordionContent.style.display = 'none'; // Hide the accordion content section
      }
  }

  // Handle clicks on okeReviews-reviewsSummary to open accordion and scroll
  const reviewsSummary = document.querySelector('.okeReviews-reviewsSummary');
  if (reviewsSummary) {
      reviewsSummary.addEventListener('click', function() {
          // Find the first accordion toggle on the page (or adjust selector as needed)
          const firstToggle = document.querySelector('[data-accordion_identifier-toggle]');
          
          if (firstToggle) {
              const accordionKey = firstToggle.getAttribute('data-accordion_identifier-toggle');
              
              // Open the accordion
              openAccordion(accordionKey);
              
              // Scroll to the accordion section
              const accordionSection = document.querySelector(`[data-accordion_identifier="${accordionKey}"]`);
              if (accordionSection) {
                  // Small delay to ensure accordion opens before scrolling
                  setTimeout(() => {
                      accordionSection.scrollIntoView({ 
                          behavior: 'smooth', 
                          block: 'start' 
                      });
                  }, 100);
              }
          }
      });
  }
});